import React from "react";
import { Spin, Icon, Table, Button, Modal, Tooltip, Row, Col, Input } from "antd";

import ArticulosMultiplosRequest from '../../services/ArticulosMultiplos';
import FormAsignarUnidad from "./FormAsignarUnidad";

import { openNotification } from '../../util/notificaciones';
import ResponsiveCard from "../Common/ResponsiveCard";
import BaseComponent from "../Common/BaseComponent";
const { confirm } = Modal;

export default class AsignacionUDM extends BaseComponent {
    state = {
        cargando: false,
        modalAsignarUDM: false,
        asignarUDMSelected: null,
        arrArticulos: [],
        filtros: {
            filtro: undefined,
            page: undefined
        },
        paginacion: {},
        filterText: "",
        disableApplyFilters: true
    }

    /**
     * Comportamiento del componente cargarArticulosMultiplos
     */
    componentDidMount() {
        this.cargarArticulosMultiplos();
    }

    cargarArticulosMultiplos = () => {
        let state = { ...this.state }

        this.setState({ cargando: true }, () => {
            ArticulosMultiplosRequest.ListarArticulosMultiplos(state.filtros)
                .then( articulosResp => {
                    state.arrArticulos = articulosResp.data.results;
                    state.paginacion = {
                        current: 1,
                        total: articulosResp.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }
                    
                    state.cargando = false;
                    this.setState(state);
                })
                .catch(err => {
                    this.setState({ cargando: false });
                });
        });
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() === "") {
            state.disableApplyFilters = true
        } else {
            state.disableApplyFilters = false
        }

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.filtro = value.trim() === "" ? undefined : value.trim()

        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     */
    filtrarBack = () => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }
        state.filtros.page = 1;
        state.cargando = true;

        this.setState(state, () => {
            ArticulosMultiplosRequest.ListarArticulosMultiplos(state.filtros).then(response => {
                state.arrArticulos = response.data.results
                state.cargando = false
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 10,
                    showTitle: false
                }
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        })
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.filtros.filtro = undefined;
        state.filtros.page = 1;
        state.filterText = "";
        state.arrArticulos = [];
        state.selectedRows = [];
        state.paginacion = {};
        this.setState(state, this.filtrarBack);
        openNotification(
            "Los filtros se han limpiado correctamente.", 
            "Filtros limpiados correctamente", 
            true
        );
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState(state, () => {
            ArticulosMultiplosRequest.ListarArticulosMultiplos(state.filtros, paginaSiguiente).then(response => {
                state.paginacion.current = paginaSiguiente
                state.arrArticulos = response.data.results
                state.cargando = false
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error al listar artículos", false)
            })
        })
    }

    /**
     * Función para mostar el modal para agregar una nueva unidad de medida
     * 
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        this.setState({ modalAsignarUDM: true })
    }

    /**
     * Función para esconder modal
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state };
        state.modalAsignarUDM = false;
        state.asignarUDMSelected = null;
        this.setState(state);
        
        if(value) this.cargarArticulosMultiplos()
    }

    /**
     * Función para mostrar la confirmación para eliminar 
     * la notificación.
     * @param: nada.
     * @return: nada.
     */
    showConfirmDelete = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro de eliminar la configuración de la unidad de medida?</b> Se borrará la configuración definitivamente.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-eliminar-unidad-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-eliminar-unidad-form',
            },
            onOk: () => {
                this.setState({ cargando: true });
                
                ArticulosMultiplosRequest.eliminarConfArticulosMult(this.state.asignarUDMSelected.id)
                    .then(resp => {
                        this.setState({cargando:false});
                        openNotification(
                            resp?.data?.cuerpo,
                            resp?.data?.titulo,
                            true
                        );
                        this.cargarArticulosMultiplos();
                    })
                    .catch(err => {
                        this.setState({cargando: false});
                        openNotification(
                            err?.data?.cuerpo,
                            err?.data?.tiulo,
                            false
                        )
                    });
            },
        });
    }

    render() {
        const columnaAsignacionUDM = [
            {
                title: "Drive",
                dataIndex: "sitio.nombre",
                key: "sitio"
            },
            {
                title: "Artículo",
                dataIndex: "articulo.descripcion",
                key: "articulo.descripcion"
            },
            {
                title: "Unidad de Medida",
                dataIndex: "unidad_medida",
                key: "unidad_medida"
            },
            {
                title: "Unidad de Medida SAP",
                dataIndex: "unidad_medida_sap",
                key: "unidad_medida_sap"
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Ver detalle configuración"}>
                                <Button
                                    id='boton-detalle-unidad'
                                    icon="eye"
                                    className="btnEditar"
                                    onClick={() =>{
                                        this.setState({asignarUDMSelected: record, modo: 'ver'}, this.showModal())
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Editar configuración"}>
                                <Button
                                    id='boton-editar-unidad'
                                    icon="edit"
                                    className="btnEditar"
                                    onClick={() =>{
                                        this.setState({asignarUDMSelected: record, modo:'editar'}, this.showModal())
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Eliminar configuración"}>
                                <Button
                                    id='boton-eliminar-unidad'
                                    icon="delete"
                                    className="btnEditar"
                                    onClick={() =>{
                                        this.setState({asignarUDMSelected: record}, this.showConfirmDelete)
                                    }}
                                >
                                </Button>
                            </Tooltip>
                        </span>
                    </div>
                )
            }
        ];

        return (
            <ResponsiveCard
                id="ParentSize"
                title="Módulo asignar unidad de medida"
                extra={
                    <div>
                        <Button
                            className="btnVerCrearGuardar"
                            type="primary"
                            id="boton-nueva-udm-articulo-modulo"
                            onClick={() => {
                                this.setState({ modo: 'nuevo', tipo_modal: 'editar' }, () => {
                                    this.showModal();
                                })

                            }}
                        >
                            Nueva configuración
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row>
                            <Col span={12}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Drive">
                                    <Input
                                        autoFocus={true}
                                        maxLength={50}
                                        id="input-buscar-categoria-modulo"
                                        placeholder="Buscar por Drive"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <div className="center-down">
                                    <Tooltip placement="top" title="Borrar filtros">
                                        <Button 
                                            id="boton-borrar-filtros-articulos" 
                                            type="default" 
                                            icon="delete" 
                                            className={this.state.disableApplyFilters ? 'disableBtn' : ''} 
                                            style={{ width: '100%', marginBottom: "30px", marginTop: '1.3em' }} 
                                            onClick={this.cleanFilters}
                                        >
                                        </Button>
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                    >
                        <Table
                            size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            columns={columnaAsignacionUDM}
                            rowKey={usuarios => usuarios.id}
                            dataSource={this.state.arrArticulos}
                            pagination={this.state.paginacion}
                        />
                    </Spin>
                </div>
                <FormAsignarUnidad
                    esconderModal={this.esconderModal}
                    modo={this.state.modo}
                    visible={this.state.modalAsignarUDM}
                    asignarUDM_selected={this.state.asignarUDMSelected} 
                >
                </FormAsignarUnidad>
            </ResponsiveCard>
        );
    }
}
